import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {
  getWindow(): Window {
    return window;
  }

  getLocation(): Location {
    return window.location;
  }

  scrollTop() {
    const content = document.body.querySelector('#content-area');
    if (content) {
      content.scrollTop = 0;
    }
  }
}
